function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  fillRule: "nonzero",
  opacity: 0.895,
  cx: 50,
  cy: 50,
  r: 50
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#252525",
  strokeWidth: 4.345,
  d: "M81.97 34.742l-10.016-4.471h0l-4.556 10.196"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.788 24.725A27.539 27.539 0 0049.807 22C34.449 22 22 34.536 22 50s12.45 28 27.807 28 27.806-12.536 27.806-28a28.003 28.003 0 00-5.53-16.76",
  stroke: "#252525",
  strokeWidth: 4.345
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.957 59.063c3.432 0 5.544-2.134 5.544-5.038v-.044c0-2.86-2.046-3.96-4.136-4.312l3.894-3.718V43.4H29.853v2.904h6.05L32.229 50l.528 2.156h1.408c1.892 0 3.014.704 3.014 1.958v.044c0 1.144-.902 1.87-2.178 1.87-1.562 0-2.662-.66-3.718-1.848l-2.332 2.222c1.32 1.562 3.234 2.662 6.006 2.662zm13.398 0c3.344 0 5.874-2.178 5.874-5.324v-.044c0-3.212-2.354-4.906-5.412-4.906-1.408 0-2.376.44-3.19.99.11-1.342.792-3.564 3.102-3.564 1.32 0 2.134.462 3.146 1.232l1.782-2.618c-1.364-1.078-2.728-1.694-4.818-1.694-4.598 0-6.754 3.652-6.754 8.404v.044c0 3.058.704 4.708 1.826 5.83 1.078 1.078 2.442 1.65 4.444 1.65zm-.132-2.904c-1.672 0-2.684-.99-2.684-2.288v-.044c0-1.298.968-2.222 2.64-2.222 1.672 0 2.684.946 2.684 2.244v.044c0 1.32-.968 2.266-2.64 2.266zm14.41-13.024c4.07 0 6.82 3.454 6.82 7.92v.044c0 4.466-2.75 7.964-6.864 7.964s-6.82-3.454-6.82-7.92V51.1c0-4.466 2.772-7.964 6.864-7.964zm-.044 3.058c-2.024 0-3.344 2.046-3.344 4.862v.044c0 2.816 1.342 4.906 3.388 4.906s3.344-2.068 3.344-4.862V51.1c0-2.794-1.364-4.906-3.388-4.906z",
  fill: "#252525",
  fillRule: "nonzero"
}));
function Svg360View(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default Svg360View;